module.exports = __webpack_public_path__ + "static/media/vocals.63507975.mp3";